module.exports = __webpack_public_path__ + "static/media/25_shape_r.02b9b92c.webp";